module.exports = __webpack_public_path__ + "static/whatsapp-e9f0fe4ee8ab44c98c94820908d822e3.png";